import _BaseTable from './BaseTable';
import _PrimaryTable from './PrimaryTable';

import './style';

export * from './type';
export * from './interface';

export const BaseTable = _BaseTable;
export const PrimaryTable = _PrimaryTable;
export const Table = PrimaryTable;

export default Table;
